import { AppState } from '../../types';
import { UI_REDUCER } from '../reducer';
import { CHAT_WIDGET_REDUCER } from './reducer';

const selectChatWidget = (state: AppState) =>
  state[UI_REDUCER][CHAT_WIDGET_REDUCER];

export const isWindowOpenSelector = (state: AppState) =>
  selectChatWidget(state).isWindowOpen;
